module.exports = __webpack_public_path__ + "static/media/2-3-3_OPP_Rainbow_03.be474a27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-3-3_OPP_Rainbow_03.jpg
// module id = 1724
// module chunks = 0